import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Result } from 'app/core/models/result';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuditListModel } from 'app/audit/models/audit-list.model';
import { AuditService } from 'app/audit/services/audit.service';

@Component({
    selector: 'app-add-audit',
    templateUrl: './add-audit.component.html',
    styleUrls: ['./add-audit.component.css']
})
export class AddAuditComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    audits: AuditListModel[];
    submitAttempt: boolean = false;
    addAuditFormGroup: FormGroup;

    constructor(
        private auditService: AuditService,
        private fb: FormBuilder,
		private location: Location,
        private router: Router
    ) {
    }

    ngOnInit() {
        this.headerTitle = {
            title: 'Add Audit', breadcrumbs: [
                { title: 'Audits', url: ['/audit'] }
            ]
        }
        this.initializeForm();
    }

    initializeForm(): void {
        this.addAuditFormGroup = this.fb.group(
            {
                name: ['', Validators.required],
                description: [''],
                isActive: [true, Validators.required]
            }
        );
    }

    addAudit(): void {
        this.submitAttempt = true;
        if (this.addAuditFormGroup.valid) {
            const formValue = this.addAuditFormGroup.value;
            this.auditService.create(formValue).subscribe(
                companyId => {
                    this.router.navigate(['./audit']);
                },
                error => {
                    this.errors = (<Result>error).errorList;
                });
        }
    }

    onBack(): void {
        this.location.back();
    }
}
